var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _RtrViewerMV_instances, _RtrViewerMV_app, _RtrViewerMV_isRtrInitialized, _RtrViewerMV_viewerStore, _RtrViewerMV_computeSelectors, _RtrViewerMV_initCallbacks, _RtrViewerMV_initLenses, _RtrViewerMV_initLocale, _RtrViewerMV_initMetadata, _RtrViewerMV_initProducts, _RtrViewerMV_initUi;
import to from 'await-to-js';
import { DEFAULT_ANIMATION_AT_LANDING, DEFAULT_BACKGROUND, DEFAULT_BLUR_VISIBILITY, DEFAULT_BUTTONS_VISIBILITY, DEFAULT_CALLBACK, DEFAULT_LABELS_DELAY, DEFAULT_ORBIT_POINT, DEFAULT_OVERLAY_FULLSCREEN, DEFAULT_OVERLAY_SELECTOR, DEFAULT_OVERVIEW_VISIBILITY, DEFAULT_SHOW_TRANSITIONS_SLIDER, DEFAULT_TRANSMISSION_CLEAR_ALPHA, DEFAULT_TRANSMISSION_CLEAR_COLOR, DEFAULT_TRANSPARENT, DEFAULT_RTR_SETTINGS_BOUNDING_AREA, DEFAULT_RTR_SETTINGS_BOUNDING_FIT, } from '@/constants';
const loadDependencies = () => {
    // Preloaded in the same wave; a failure surfaces where they are imported.
    for (const preload of [
        import('@/components/App.vue'),
        import('@/components/Viewer.vue'),
        import('@/components/views/View.vue'),
    ]) {
        preload.catch(() => { });
    }
    return Promise.all([
        import('pinia'),
        import('vue'),
        import('@/plugins/resetStore'),
        import('@/directives/tooltip'),
        import('@/stores/viewer'),
        import('@/validators'),
    ]);
};
class RtrViewerMV {
    constructor() {
        _RtrViewerMV_instances.add(this);
        _RtrViewerMV_app.set(this, void 0); // Vue App instance
        _RtrViewerMV_isRtrInitialized.set(this, void 0);
        _RtrViewerMV_viewerStore.set(this, void 0);
        __classPrivateFieldSet(this, _RtrViewerMV_app, null, "f");
        __classPrivateFieldSet(this, _RtrViewerMV_isRtrInitialized, false, "f");
        __classPrivateFieldSet(this, _RtrViewerMV_viewerStore, null, "f");
    }
    async init({ key, callbacks: { onCameraReset = DEFAULT_CALLBACK, onClose = DEFAULT_CALLBACK, onComponentSelected = DEFAULT_CALLBACK, onLabelSelected = DEFAULT_CALLBACK, } = {}, data: { locale, selector, products, settings: { animationAtLanding = DEFAULT_ANIMATION_AT_LANDING, applicativeZoom, background = DEFAULT_BACKGROUND, bannerText, boundingArea = DEFAULT_RTR_SETTINGS_BOUNDING_AREA, boundingFit = DEFAULT_RTR_SETTINGS_BOUNDING_FIT, blurVisibility = DEFAULT_BLUR_VISIBILITY, buttonsVisibility = DEFAULT_BUTTONS_VISIBILITY, labelsDelay = DEFAULT_LABELS_DELAY, loaderText, orbitPoint = DEFAULT_ORBIT_POINT, overlayFullscreen = DEFAULT_OVERLAY_FULLSCREEN, overviewVisibility = DEFAULT_OVERVIEW_VISIBILITY, showTransitionsSlider = DEFAULT_SHOW_TRANSITIONS_SLIDER, transmissionClearAlpha = DEFAULT_TRANSMISSION_CLEAR_ALPHA, transmissionClearColor = DEFAULT_TRANSMISSION_CLEAR_COLOR, transparent = DEFAULT_TRANSPARENT, } = {}, }, debug = {}, metadata: { envs: { asset: envAsset = __RTR_ENVIRONMENT__, catalog: envCatalog = __RTR_ENVIRONMENT__, ms: envMs = __RTR_ENVIRONMENT__, } = {}, qa = false, } = {}, }) {
        if (__classPrivateFieldGet(this, _RtrViewerMV_isRtrInitialized, "f"))
            return;
        const [{ createPinia, storeToRefs }, { createApp }, { default: resetStore }, { default: tooltipDirective }, { useViewerStore }, { validateLocale, validateProducts, validateSelector, validateAnimations, validateApplicativeZoom, validateBackground, validateBannerText, validateBlurVisibility, validateButtonsVisibility, validateLabelsDelay, validateLoaderText, validateOverlayFullscreen, validateOverviewVisibility, validateShowTransitionsSlider, validateTransparent, },] = await loadDependencies();
        const { default: App } = await import('@/components/App.vue');
        __classPrivateFieldSet(this, _RtrViewerMV_app, createApp(App), "f");
        const pinia = createPinia();
        pinia.use(resetStore);
        __classPrivateFieldGet(this, _RtrViewerMV_app, "f").use(pinia);
        __classPrivateFieldGet(this, _RtrViewerMV_app, "f").directive('tooltip', tooltipDirective);
        const viewerStore = useViewerStore();
        __classPrivateFieldSet(this, _RtrViewerMV_viewerStore, viewerStore, "f");
        const { currentId, featureLicensingKey } = storeToRefs(viewerStore);
        featureLicensingKey.value = key;
        await __classPrivateFieldGet(this, _RtrViewerMV_instances, "m", _RtrViewerMV_initCallbacks).call(this, {
            onCameraReset,
            onClose,
            onComponentSelected,
            onLabelSelected,
        });
        const [errValidation] = await to(Promise.all([
            validateLocale(locale),
            validateProducts(products),
            validateSelector(selector),
            // Settings
            validateAnimations(animationAtLanding),
            validateApplicativeZoom(applicativeZoom),
            validateBackground(background),
            validateBannerText(bannerText),
            validateBlurVisibility(blurVisibility),
            validateButtonsVisibility(buttonsVisibility),
            validateLabelsDelay(labelsDelay),
            validateLoaderText(loaderText),
            validateOverlayFullscreen(overlayFullscreen),
            validateOverviewVisibility(overviewVisibility),
            validateShowTransitionsSlider(showTransitionsSlider),
            validateTransparent(transparent),
        ]));
        if (errValidation)
            throw errValidation;
        const { RtrViewer } = await import('@luxottica/rtr-viewer');
        console.group(`RTR viewer Master Version v${__VITE_LIB_VERSION__}`);
        console.log(`RTR viewer v${RtrViewer.getVersion()}`);
        console.log('Environment:', __MV_ENVIRONMENT__);
        console.group('Metadata');
        console.log('envAsset:', envAsset);
        console.log('envCatalog:', envCatalog);
        console.log('envMs:', envMs);
        console.log('qa:', qa);
        console.groupEnd();
        console.groupEnd();
        // Animations
        const { useAnimationsStore } = await import('@/stores/animations');
        const animationsStore = useAnimationsStore();
        animationsStore.animationAtLanding = animationAtLanding;
        const metadata = {
            envs: {
                asset: envAsset,
                catalog: envCatalog,
                ms: envMs,
            },
            qa,
        };
        await __classPrivateFieldGet(this, _RtrViewerMV_instances, "m", _RtrViewerMV_initMetadata).call(this, metadata);
        // Locale, products and lenses are requested together
        const productsPromise = to(__classPrivateFieldGet(this, _RtrViewerMV_instances, "m", _RtrViewerMV_initProducts).call(this, products, metadata)).then(([err]) => err);
        const [[errLocale], errProducts, [errLenses]] = await Promise.all([
            to(__classPrivateFieldGet(this, _RtrViewerMV_instances, "m", _RtrViewerMV_initLocale).call(this, locale)),
            productsPromise,
            to(__classPrivateFieldGet(this, _RtrViewerMV_instances, "m", _RtrViewerMV_initLenses).call(this, productsPromise)),
        ]);
        if (errLocale)
            throw errLocale;
        if (errProducts)
            throw errProducts;
        if (errLenses) {
            console.warn(`Failed to initialize lenses. Error: ${errLenses.message}`, errLenses);
        }
        if (applicativeZoom) {
            const { useZoomStore } = await import('@/stores/zoom');
            const zoomStore = useZoomStore();
            await zoomStore.setApplicativeZoom(applicativeZoom);
        }
        // Selectors
        const { embeddedSelector, overlaySelector } = await __classPrivateFieldGet(this, _RtrViewerMV_instances, "m", _RtrViewerMV_computeSelectors).call(this, selector);
        const experience = embeddedSelector
            ? 'embedded'
            : 'overlay';
        await __classPrivateFieldGet(this, _RtrViewerMV_instances, "m", _RtrViewerMV_initUi).call(this, {
            experience,
            overlaySelector,
            settings: {
                background,
                bannerText,
                blurVisibility,
                buttonsVisibility,
                labelsDelay,
                loaderText,
                orbitPoint,
                overlayFullscreen,
                overviewVisibility,
                showTransitionsSlider,
            },
        });
        viewerStore.boundingArea = boundingArea;
        viewerStore.boundingFit = boundingFit;
        viewerStore.debug = debug;
        viewerStore.transmissionClearAlpha = transmissionClearAlpha;
        viewerStore.transmissionClearColor = transmissionClearColor;
        viewerStore.transparent = transparent;
        let rootContainer;
        if (experience === 'overlay') {
            const overlayContainer = document.createElement('div');
            overlayContainer.id = DEFAULT_OVERLAY_SELECTOR;
            document.body.appendChild(overlayContainer);
            rootContainer = `#${DEFAULT_OVERLAY_SELECTOR}`;
        }
        else {
            rootContainer = embeddedSelector;
        }
        __classPrivateFieldGet(this, _RtrViewerMV_app, "f").mount(rootContainer);
        const { appMountedPromise } = await import('@/utils/promises');
        await appMountedPromise;
        const [errInit] = await to(viewerStore.initViewer(currentId.value));
        if (errInit)
            throw errInit;
        __classPrivateFieldSet(this, _RtrViewerMV_isRtrInitialized, true, "f");
    }
    // GETTERs
    /**
     * Returns the transitions lenses catalogue for the selected environment.
     * @param env The environment to use for the lenses catalogue. Defaults to production.
     * @see https://rtrmv.essilorluxottica.com/guide/version/4/guide/methods-getters.html#getlensescatalogue
     */
    async getLensesCatalogue(env) {
        const { getLensesCatalogueAdapter } = await import('@/adapters');
        return getLensesCatalogueAdapter(env);
    }
    /**
     * Returns the glasses data currently loaded in the viewer.
     * @returns The glasses data.
     * @see https://rtrmv.essilorluxottica.com/guide/version/4/guide/methods-getters.html#getglassesdata
     */
    async getGlassesData() {
        if (!__classPrivateFieldGet(this, _RtrViewerMV_isRtrInitialized, "f"))
            return;
        return __classPrivateFieldGet(this, _RtrViewerMV_viewerStore, "f").getGlassesData();
    }
    /**
     * Returns the version of the library, as specified in the `package.json` file.
     * @see https://rtrmv.essilorluxottica.com/guide/version/4/guide/methods-getters.html#getversion
     */
    getVersion() {
        return __VITE_LIB_VERSION__;
    }
    /**
     * Returns `true` if the given ID is available, otherwise returns `false`.
     * @param id The ID to check for availability
     * @param metadata An object containing the environment settings and whether to use QA mode
     * @see https://rtrmv.essilorluxottica.com/guide/version/4/guide/methods-getters.html#isidavailable
     */
    async isIdAvailable(id, { envs: { asset: envAsset = __RTR_ENVIRONMENT__, catalog: envCatalog = __RTR_ENVIRONMENT__, ms: envMs = __RTR_ENVIRONMENT__, } = {}, qa = false, } = {}) {
        const { RtrViewer } = await import('@luxottica/rtr-viewer');
        return RtrViewer.isIdAvailable(id, {
            envs: {
                asset: envAsset,
                catalog: envCatalog,
                ms: envMs,
            },
            qa,
        });
    }
    /**
     * Returns `true` if the given SunRx lens is available, otherwise `false`.
     * @param params — The parameters object
     * @param params.clen — The SunRx lens identifier
     * @param params.env — The environment to check against (default: 'production')
     * @see https://rtrmv.essilorluxottica.com/guide/version/4/guide/methods-getters.html#islensavailable
     */
    async isLensAvailable({ clen, env, }) {
        const { isLensAvailableAdapter } = await import('@/adapters');
        return isLensAvailableAdapter({ clen, env });
    }
    /**
     * It returns `true` if the viewer is initialized, `false` otherwise.
     * @see https://rtrmv.essilorluxottica.com/guide/version/4/guide/methods-getters.html#isinitialized
     */
    isInitialized() {
        return __classPrivateFieldGet(this, _RtrViewerMV_isRtrInitialized, "f");
    }
    /**
     * It returns a Promise that resolves to `true` if the browser being used supports both WebGl2 and ResizeObserver, and `false` otherwise.
     * @see https://rtrmv.essilorluxottica.com/guide/version/4/guide/methods-getters.html#issupported
     */
    async isSupported() {
        const { RtrViewer } = await import('@luxottica/rtr-viewer');
        return RtrViewer.isSupported();
    }
    // SETTERs
    /**
     * It returns a Promise that resolves once the zoom level has been set. The zoom level is applied to the entire application, affecting the size of text and icons.
     * @param zoom The desired zoom level, expressed as a percentage.
     * @see https://rtrmv.essilorluxottica.com/guide/version/4/guide/methods-setters.html#setapplicativezoom
     */
    async setApplicativeZoom(zoom) {
        if (!__classPrivateFieldGet(this, _RtrViewerMV_isRtrInitialized, "f"))
            return;
        console.log('[setApplicativeZoom]', zoom);
        const { useZoomStore } = await import('@/stores/zoom');
        const zoomStore = useZoomStore();
        await zoomStore.setApplicativeZoom(zoom);
    }
    /**
     * It returns a Promise that resolves once the background has been set. The background can be either a solid color or an image.
     * @param newBackground The new background to set
     * @see https://rtrmv.essilorluxottica.com/guide/version/4/guide/methods-setters.html#setbackground
     */
    async setBackground(newBackground) {
        if (!__classPrivateFieldGet(this, _RtrViewerMV_isRtrInitialized, "f"))
            return;
        console.log('[setBackground]', newBackground);
        const { setBackground } = __classPrivateFieldGet(this, _RtrViewerMV_viewerStore, "f");
        const [err] = await to(setBackground(newBackground));
        if (err)
            throw err;
    }
    /**
     * Sets the bounding area used to frame the model when the camera is reset.
     * @param boundingArea An object representing the bounding area, which includes the coordinates of the top-left and bottom-right points.
     * @returns A Promise that resolves once the bounding area has been set.
     * @see https://rtrmv.essilorluxottica.com/guide/version/4/guide/methods-setters.html#setboundingarea
     */
    async setBoundingArea(boundingArea) {
        if (!__classPrivateFieldGet(this, _RtrViewerMV_isRtrInitialized, "f"))
            return;
        console.log('[setBoundingArea]', boundingArea);
        const { setBoundingArea } = __classPrivateFieldGet(this, _RtrViewerMV_viewerStore, "f");
        const [err] = await to(setBoundingArea(boundingArea));
        if (err)
            throw err;
    }
    /**
     * Sets how the model fits inside the bounding area when the camera is reset.
     * @param value The bounding fit value, which can be either horizontal, vertical, or auto.
     * @see https://rtrmv.essilorluxottica.com/guide/version/4/guide/methods-setters.html#setboundingfit
     */
    async setBoundingFit(boundingFit) {
        if (!__classPrivateFieldGet(this, _RtrViewerMV_isRtrInitialized, "f"))
            return;
        console.log('[setBoundingFit]', boundingFit);
        const { setBoundingFit } = __classPrivateFieldGet(this, _RtrViewerMV_viewerStore, "f");
        const [err] = await to(setBoundingFit(boundingFit));
        if (err)
            throw err;
    }
    /**
     * Sets whether to lock the camera's vertical rotation, which restricts the camera movement to a horizontal plane.
     * This can be useful for certain applications where a consistent viewing angle is desired.
     * @param value A boolean value indicating whether to lock the camera's vertical rotation (`true`) or allow full rotation (`false`).
     * @see https://rtrmv.essilorluxottica.com/guide/version/4/guide/methods-setters.html#setcameraverticallock
     */
    async setCameraVerticalLock(value) {
        if (!__classPrivateFieldGet(this, _RtrViewerMV_isRtrInitialized, "f"))
            return;
        console.log('[setCameraVerticalLock]', value);
        const { setCameraVerticalLock } = __classPrivateFieldGet(this, _RtrViewerMV_viewerStore, "f");
        const [err] = await to(setCameraVerticalLock(value));
        if (err)
            throw err;
    }
    /**
     * Sets debug options for the viewer.
     * @param debug The debug options to set.
     * @returns A Promise that resolves once the debug options have been set.
     * @see https://rtrmv.essilorluxottica.com/guide/version/4/guide/methods-setters.html#setdebug
     */
    async setDebug(debug) {
        if (!__classPrivateFieldGet(this, _RtrViewerMV_isRtrInitialized, "f"))
            return;
        console.log('[setDebug]', debug);
        const { setDebug } = __classPrivateFieldGet(this, _RtrViewerMV_viewerStore, "f");
        const [err] = await to(setDebug(debug));
        if (err)
            throw err;
    }
    /**
     * Sets the product to display using an ID (`upc`, `moco`, or `token`).
     *
     * @param id The ID of the product to be displayed, which can be a UPC, MoCo, or token.
     * @param autoResetCamera Whether to automatically reset the camera when setting the product ID.
     * @see https://rtrmv.essilorluxottica.com/guide/version/4/guide/methods-setters.html#setid
     */
    async setId(id, autoResetCamera) {
        if (!__classPrivateFieldGet(this, _RtrViewerMV_isRtrInitialized, "f"))
            return;
        console.log('[setId]', id);
        const { setId } = __classPrivateFieldGet(this, _RtrViewerMV_viewerStore, "f");
        const [err] = await to(setId(id, autoResetCamera));
        if (err)
            throw err;
    }
    /**
     * Sets the opacity of the lenses.
     * @param value The opacity of the lenses, which should be a number between `0` and `1`.
     * @see https://rtrmv.essilorluxottica.com/guide/version/4/guide/methods-setters.html#setlensesopacity
     */
    async setLensesOpacity(opacity) {
        if (!__classPrivateFieldGet(this, _RtrViewerMV_isRtrInitialized, "f"))
            return;
        console.log('[setLensesOpacity]', opacity);
        const { setLensesOpacity } = __classPrivateFieldGet(this, _RtrViewerMV_viewerStore, "f");
        const [err] = await to(setLensesOpacity(opacity));
        if (err)
            throw err;
    }
    /**
     * Sets the rendering material of the lenses.
     *
     * @param lensMaterial Lens material definition (`SunRXId | TransitionsGradientId | StaticLensId | TransitionsGradientLens`).
     * @returns A promise that resolves when the material is applied.
     * @see https://rtrmv.essilorluxottica.com/guide/version/4/guide/methods-setters.html#setlensmaterial
     */
    async setLensMaterial(lensMaterial) {
        if (!__classPrivateFieldGet(this, _RtrViewerMV_isRtrInitialized, "f"))
            return;
        console.log('[setLensMaterial]', lensMaterial);
        const { setLensMaterial } = __classPrivateFieldGet(this, _RtrViewerMV_viewerStore, "f");
        const [err] = await to(setLensMaterial(lensMaterial));
        if (err)
            throw err;
    }
    /**
     * Applies a personalization to a target area of the model.
     * @param personalization An object representing the personalization to be applied, which includes the target area and either text or image properties.
     * @see https://rtrmv.essilorluxottica.com/guide/version/4/guide/methods-setters.html#setpersonalization
     */
    async setPersonalization(personalization) {
        if (!__classPrivateFieldGet(this, _RtrViewerMV_isRtrInitialized, "f"))
            return;
        console.log('[setPersonalization]', personalization);
        const { setPersonalization } = __classPrivateFieldGet(this, _RtrViewerMV_viewerStore, "f");
        const [err] = await to(setPersonalization(personalization));
        if (err)
            throw err;
    }
    /**
     * Sets lens prescriptions.
     *
     * @param prescriptions Prescription values to apply.
     * @see https://rtrmv.essilorluxottica.com/guide/version/4/guide/methods-setters.html#setprescriptions
     */
    async setPrescriptions(prescriptions) {
        if (!__classPrivateFieldGet(this, _RtrViewerMV_isRtrInitialized, "f"))
            return;
        console.log('[setPrescriptions]', prescriptions);
        const { setPrescriptions } = __classPrivateFieldGet(this, _RtrViewerMV_viewerStore, "f");
        const { toRaw } = await import('vue');
        const [err] = await to(setPrescriptions(toRaw(prescriptions)));
        if (err)
            throw err;
    }
    /**
     * Sets whether to show the labels on the 3D model.
     * @param show A boolean value indicating whether to show labels (`true`) or hide them (`false`).
     * @see https://rtrmv.essilorluxottica.com/guide/version/4/guide/methods-setters.html#setshowlabels
     */
    async setShowLabels(show) {
        if (!__classPrivateFieldGet(this, _RtrViewerMV_isRtrInitialized, "f"))
            return;
        console.log('[setShowLabels]', show);
        const { useLabelsStore } = await import('@/stores/labels');
        const labelsStore = useLabelsStore();
        const { setShowLabels } = labelsStore;
        const [err] = await to(setShowLabels(show));
        if (err)
            throw err;
    }
    /**
     * Sets the alpha value for the transmission render target.
     * This parameter is only taken into consideration if `transparent` is `true`.
     * @param value The clear alpha value to be set, which should be in the range [0, 1].
     * @see https://rtrmv.essilorluxottica.com/guide/version/4/guide/methods-setters.html#settransmissionclearalpha
     */
    async setTransmissionClearAlpha(value) {
        if (!__classPrivateFieldGet(this, _RtrViewerMV_isRtrInitialized, "f"))
            return;
        console.log('[setTransmissionClearAlpha]', value);
        const { setTransmissionClearAlpha } = __classPrivateFieldGet(this, _RtrViewerMV_viewerStore, "f");
        const [err] = await to(setTransmissionClearAlpha(value));
        if (err)
            throw err;
    }
    /**
     * Sets the background color for the transmission render target.
     * This parameter is only taken into consideration if `transparent` is `true`.
     * @param value The clear color to be set.
     * @see https://rtrmv.essilorluxottica.com/guide/version/4/guide/methods-setters.html#settransmissionclearcolor
     */
    async setTransmissionClearColor(value) {
        if (!__classPrivateFieldGet(this, _RtrViewerMV_isRtrInitialized, "f"))
            return;
        console.log('[setTransmissionClearColor]', value);
        const { setTransmissionClearColor } = __classPrivateFieldGet(this, _RtrViewerMV_viewerStore, "f");
        const [err] = await to(setTransmissionClearColor(value));
        if (err)
            throw err;
    }
    /**
     * Sets whether the canvas background should be transparent or not.
     * When `true`, the background becomes transparent, allowing the content behind the canvas to be visible.
     * When `false`, the background is opaque.
     *
     * With a transparent background, materials are rendered differently and the `transmissionClearAlpha` and `transmissionClearColor` parameters are taken into account. These can be modified via {@link setTransmissionClearAlpha} and {@link setTransmissionClearColor}.
     * @param value A boolean value indicating whether to enable a transparent background (`true`) or an opaque background (`false`).
     * @see https://rtrmv.essilorluxottica.com/guide/version/4/guide/methods-setters.html#settransparent
     */
    async setTransparent(value) {
        if (!__classPrivateFieldGet(this, _RtrViewerMV_isRtrInitialized, "f"))
            return;
        console.log('[setTransparent]', value);
        const { setTransparent } = __classPrivateFieldGet(this, _RtrViewerMV_viewerStore, "f");
        const [err] = await to(setTransparent(value));
        if (err)
            throw err;
    }
    /**
     * Overrides visibility of specific components.
     * @param visibilities An array of objects representing the visibilities to be set, each with a name, type, and visibility status.
     * @see https://rtrmv.essilorluxottica.com/guide/version/4/guide/methods-setters.html#setvisibilities
     */
    async setVisibilities(visibilities) {
        if (!__classPrivateFieldGet(this, _RtrViewerMV_isRtrInitialized, "f"))
            return;
        console.log('[setVisibilities]', visibilities);
        const { setVisibilities } = __classPrivateFieldGet(this, _RtrViewerMV_viewerStore, "f");
        const [err] = await to(setVisibilities(visibilities));
        if (err)
            throw err;
    }
    // ACTIONs
    /**
     * Clears the applied lens material and restores the default behavior.
     * @see https://rtrmv.essilorluxottica.com/guide/version/4/guide/methods-actions.html#clearlensmaterial
     */
    async clearLensMaterial() {
        if (!__classPrivateFieldGet(this, _RtrViewerMV_isRtrInitialized, "f"))
            return;
        console.log('[clearLensMaterial]');
        const [err] = await to(__classPrivateFieldGet(this, _RtrViewerMV_viewerStore, "f").clearLensMaterial());
        if (err)
            throw err;
    }
    /**
     * Clears all personalizations.
     * @see https://rtrmv.essilorluxottica.com/guide/version/4/guide/methods-actions.html#clearpersonalizations
     */
    async clearPersonalizations() {
        if (!__classPrivateFieldGet(this, _RtrViewerMV_isRtrInitialized, "f"))
            return;
        console.log('[clearPersonalizations]');
        const [err] = await to(__classPrivateFieldGet(this, _RtrViewerMV_viewerStore, "f").clearPersonalizations());
        if (err)
            throw err;
    }
    /**
     * Clears all lens prescriptions.
     * @see https://rtrmv.essilorluxottica.com/guide/version/4/guide/methods-actions.html#clearprescriptions
     */
    async clearPrescriptions() {
        if (!__classPrivateFieldGet(this, _RtrViewerMV_isRtrInitialized, "f"))
            return;
        console.log('[clearPrescriptions]');
        const [err] = await to(__classPrivateFieldGet(this, _RtrViewerMV_viewerStore, "f").clearPrescriptions());
        if (err)
            throw err;
    }
    /**
     * Clears all visibility overrides.
     * @see https://rtrmv.essilorluxottica.com/guide/version/4/guide/methods-actions.html#clearvisibilities
     */
    async clearVisibilities() {
        if (!__classPrivateFieldGet(this, _RtrViewerMV_isRtrInitialized, "f"))
            return;
        console.log('[clearVisibilities]');
        const [err] = await to(__classPrivateFieldGet(this, _RtrViewerMV_viewerStore, "f").clearVisibilities());
        if (err)
            throw err;
    }
    /**
     * Disposes the viewer and frees all allocated resources.
     * @see https://rtrmv.essilorluxottica.com/guide/version/4/guide/methods-actions.html#dispose
     */
    async dispose() {
        if (!__classPrivateFieldGet(this, _RtrViewerMV_isRtrInitialized, "f"))
            return;
        const { useRootStore } = await import('@/stores/root');
        const { dispose } = __classPrivateFieldGet(this, _RtrViewerMV_viewerStore, "f");
        const rootStore = useRootStore();
        const { resetStores } = rootStore;
        dispose();
        resetStores();
        __classPrivateFieldGet(this, _RtrViewerMV_app, "f")?.unmount();
        const overlayContainer = document.getElementById(DEFAULT_OVERLAY_SELECTOR);
        overlayContainer?.remove();
        __classPrivateFieldSet(this, _RtrViewerMV_isRtrInitialized, false, "f");
        __classPrivateFieldSet(this, _RtrViewerMV_viewerStore, null, "f");
        __classPrivateFieldSet(this, _RtrViewerMV_app, null, "f");
    }
    /**
     * Animates the camera to focus on a specific target in the scene.
     * @param target An object representing the camera movement target, which includes the type and value.
     * @see https://rtrmv.essilorluxottica.com/guide/version/4/guide/methods-actions.html#movecamera
     */
    async moveCamera(target) {
        if (!__classPrivateFieldGet(this, _RtrViewerMV_isRtrInitialized, "f"))
            return;
        const { moveCamera } = __classPrivateFieldGet(this, _RtrViewerMV_viewerStore, "f");
        console.log('[moveCamera]', target);
        const [err] = await to(moveCamera(target));
        if (err)
            throw err;
    }
    /**
     * Resets the camera to reframe the product.
     * @see https://rtrmv.essilorluxottica.com/guide/version/4/guide/methods-actions.html#resetcamera
     */
    async resetCamera() {
        if (!__classPrivateFieldGet(this, _RtrViewerMV_isRtrInitialized, "f"))
            return;
        console.log('[resetCamera]');
        await __classPrivateFieldGet(this, _RtrViewerMV_viewerStore, "f").resetCamera();
    }
    /**
     * Moves the camera to frame a specific token component.
     * @param params.componentId The index of the component to be selected, starting from 0.
     * @see https://rtrmv.essilorluxottica.com/guide/version/4/guide/methods-actions.html#selectcomponent
     */
    async selectComponent({ componentId }) {
        if (!__classPrivateFieldGet(this, _RtrViewerMV_isRtrInitialized, "f"))
            return;
        const { selectComponent } = __classPrivateFieldGet(this, _RtrViewerMV_viewerStore, "f");
        console.log('[selectComponent]', { componentId });
        const [err] = await to(selectComponent({ componentId }));
        if (err)
            throw err;
    }
    /**
     * Animates lens opacity to the opposite extreme (`0` or `1`).
     * @param duration The duration of the animation in milliseconds.
     * @see https://rtrmv.essilorluxottica.com/guide/version/4/guide/methods-actions.html#togglelensesopacity
     */
    async toggleLensesOpacity(duration) {
        if (!__classPrivateFieldGet(this, _RtrViewerMV_isRtrInitialized, "f"))
            return;
        const { toggleLensesOpacity } = __classPrivateFieldGet(this, _RtrViewerMV_viewerStore, "f");
        console.log('[toggleLensesOpacity]', duration);
        const [err] = await to(toggleLensesOpacity(duration));
        if (err)
            throw err;
    }
}
_RtrViewerMV_app = new WeakMap(), _RtrViewerMV_isRtrInitialized = new WeakMap(), _RtrViewerMV_viewerStore = new WeakMap(), _RtrViewerMV_instances = new WeakSet(), _RtrViewerMV_computeSelectors = 
// Private methods
async function _RtrViewerMV_computeSelectors(selector) {
    const { isUndefined, isString } = await import('lodash-es');
    if (isUndefined(selector)) {
        return {
            embeddedSelector: undefined,
            overlaySelector: 'body',
        };
    }
    if (isString(selector)) {
        return {
            embeddedSelector: selector,
            overlaySelector: 'body',
        };
    }
    return {
        embeddedSelector: selector.embedded,
        overlaySelector: selector.overlay ?? 'body',
    };
}, _RtrViewerMV_initCallbacks = async function _RtrViewerMV_initCallbacks(callbacks = {}) {
    const { onCameraReset, onClose, onComponentSelected, onLabelSelected } = callbacks;
    const { useCallbacksStore } = await import('@/stores/callbacks');
    const callbacksStore = useCallbacksStore();
    if (onCameraReset)
        callbacksStore.onCameraReset = onCameraReset;
    if (onClose)
        callbacksStore.onClose = onClose;
    if (onComponentSelected)
        callbacksStore.onComponentSelected = onComponentSelected;
    if (onLabelSelected)
        callbacksStore.onLabelSelected = onLabelSelected;
}, _RtrViewerMV_initLenses = async function _RtrViewerMV_initLenses(productsPromise) {
    const { useLensesStore } = await import('@/stores/lenses');
    const lensesStore = useLensesStore();
    const [errLenses] = await to(lensesStore.initLensesData(productsPromise));
    if (errLenses)
        throw errLenses;
}, _RtrViewerMV_initLocale = async function _RtrViewerMV_initLocale(locale) {
    const { useTranslationsStore } = await import('@/stores/translations');
    const translationsStore = useTranslationsStore();
    const { storeToRefs } = await import('pinia');
    const { i18n } = storeToRefs(translationsStore);
    const { setupI18n } = translationsStore;
    const [err] = await to(setupI18n(locale));
    if (err)
        throw err;
    __classPrivateFieldGet(this, _RtrViewerMV_app, "f").use(i18n.value);
}, _RtrViewerMV_initMetadata = async function _RtrViewerMV_initMetadata(metadata) {
    const { useMetadataStore } = await import('@/stores/metadata');
    const metadataStore = useMetadataStore();
    const { storeToRefs } = await import('pinia');
    const { envAsset, envCatalog, envMs, qa } = storeToRefs(metadataStore);
    envAsset.value = metadata.envs?.asset;
    envCatalog.value = metadata.envs?.catalog;
    envMs.value = metadata.envs?.ms;
    qa.value = metadata.qa;
}, _RtrViewerMV_initProducts = async function _RtrViewerMV_initProducts(items, metadata) {
    const [{ useProductsStore }, { RtrViewer, ValidationError }] = await Promise.all([
        import('@/stores/products'),
        import('@luxottica/rtr-viewer'),
    ]);
    const productsStore = useProductsStore();
    const { storeToRefs } = await import('pinia');
    const { products, currentProduct } = storeToRefs(productsStore);
    const { currentId } = storeToRefs(__classPrivateFieldGet(this, _RtrViewerMV_viewerStore, "f"));
    const availability = await Promise.all(items.map(product => to(RtrViewer.isIdAvailable(product.id, metadata))));
    const availableProducts = items.filter((product, index) => {
        const [err, isAvailable] = availability[index];
        if (err || !isAvailable) {
            console.warn(`${product.id.type} ${product.id.value} is not available.`);
            return false;
        }
        return true;
    });
    if (availableProducts.length === 0) {
        const error = new ValidationError({
            cause: new Error('No available products found.'),
        });
        throw error;
    }
    const { toRaw } = await import('vue');
    products.value = toRaw(availableProducts);
    const defaultProduct = products.value.find(p => p.default);
    currentProduct.value = defaultProduct ?? products.value[0];
    currentId.value = currentProduct.value.id;
}, _RtrViewerMV_initUi = async function _RtrViewerMV_initUi({ experience, overlaySelector: selector, settings, }) {
    const { useUiStore } = await import('@/stores/ui');
    const uiStore = useUiStore();
    const { storeToRefs } = await import('pinia');
    const { bannerText, blurVisibility, buttonsVisibility, labelsDelay, loaderText, overlayFullscreen, overlaySelector, overviewVisibility, showTransitionsSlider, } = storeToRefs(uiStore);
    uiStore.experience = experience;
    uiStore.initialExperience = experience;
    const { background, orbitPoint } = storeToRefs(__classPrivateFieldGet(this, _RtrViewerMV_viewerStore, "f"));
    overlaySelector.value = selector;
    bannerText.value = settings.bannerText;
    if (settings.background !== undefined)
        background.value = settings.background;
    if (settings.blurVisibility !== undefined)
        blurVisibility.value = settings.blurVisibility;
    if (settings.labelsDelay !== undefined)
        labelsDelay.value = settings.labelsDelay;
    if (settings.loaderText)
        loaderText.value = settings.loaderText;
    if (settings.orbitPoint !== undefined)
        orbitPoint.value = settings.orbitPoint;
    if (settings.overlayFullscreen !== undefined)
        overlayFullscreen.value = settings.overlayFullscreen;
    if (settings.overviewVisibility !== undefined)
        overviewVisibility.value = settings.overviewVisibility;
    if (settings.showTransitionsSlider !== undefined)
        showTransitionsSlider.value = settings.showTransitionsSlider;
    buttonsVisibility.value = {
        ...DEFAULT_BUTTONS_VISIBILITY,
        ...settings.buttonsVisibility,
    };
};
export default new RtrViewerMV();
